import { render, staticRenderFns } from "./ViewEmail.vue?vue&type=template&id=797fa4b4&scoped=true&"
import script from "./ViewEmail.vue?vue&type=script&lang=js&"
export * from "./ViewEmail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "797fa4b4",
  null
  
)

export default component.exports